import { render, staticRenderFns } from "./FeeScheduleAndInterestRates.vue?vue&type=template&id=195a9c0e&scoped=true"
import script from "./FeeScheduleAndInterestRates.vue?vue&type=script&lang=ts"
export * from "./FeeScheduleAndInterestRates.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195a9c0e",
  null
  
)

export default component.exports